import type { IconButtonProps } from '@material-ui/core'
import { IconButton, withStyles } from '@material-ui/core'
import { ChevronLeftRounded, ChevronRightRounded } from '@material-ui/icons'
import { colors } from '../../../constants/styles'

const StyledArrowButton = withStyles({
  root: {
    borderRadius: 4,
    width: 28,
    height: 28,
    backgroundColor: colors.neutral200,
    '&:hover': {
      backgroundColor: colors.neutral300,
    },
    '&.Mui-disabled': {
      backgroundColor: '#eee',
    },
  },
})(IconButton)

/**
 * Number button used in pagination to show page numbers
 */
export const NumberButton = withStyles({
  root: {
    borderRadius: 4,
    width: 28,
    height: 28,
    color: colors.neutral500,
    fontWeight: 500,
    // currently selected page is disabled and highlighted
    '&.Mui-disabled': {
      backgroundColor: colors.primary,
      color: 'white',
    },
  },
})(IconButton)

type ArrowButtonProps = {
  direction: 'left' | 'right'
} & IconButtonProps

/**
 * Left and right arrow button used in pagination
 */
export const ArrowButton = ({ direction, ...rest }: ArrowButtonProps) => (
  <StyledArrowButton {...rest}>
    {direction === 'left' ? (
      <ChevronLeftRounded style={{ color: rest.disabled ? colors.neutral400 : colors.neutral500 }} fontSize="small" />
    ) : (
      <ChevronRightRounded style={{ color: rest.disabled ? colors.neutral400 : colors.neutral500 }} fontSize="small" />
    )}
  </StyledArrowButton>
)
